import { useState, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import mohit_pic_1 from "../assets/mohit_pic_1.jpeg";
import mohit_pic_2 from "../assets/mohit_pic_2.jpeg";
import mohit_pic_3 from "../assets/mohit_pic_3.jpeg";
import mohit_pic_4 from "../assets/mohit_pic_4.jpg";

const sampleImages = [mohit_pic_1, mohit_pic_2, mohit_pic_3, mohit_pic_4];

const BouncyImageTooltip = ({ children, images = sampleImages }) => {
  const [isTooltipVisible, setTooltipVisible] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const triggerRef = useRef(null); // NEW: Create a ref for the trigger element

  // NEW: Handler for mouse movement over the trigger text
  const handleMouseMove = (e) => {
    if (!triggerRef.current) return;

    // Get the bounding box of the trigger element
    const rect = triggerRef.current.getBoundingClientRect();

    // Calculate the horizontal position of the mouse relative to the element (from 0 to 1)
    const relativeX = (e.clientX - rect.left) / rect.width;

    // Map the relative position to an image index
    const newIndex = Math.max(
      0,
      Math.min(images.length - 1, Math.floor(relativeX * images.length))
    );

    // Update the image index state
    setCurrentImageIndex(newIndex);
  };

  const tooltipVariants = {
    hidden: { opacity: 0, y: 20, scale: 0.9 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: { type: "spring", stiffness: 300, damping: 20 },
    },
  };

  return (
    <div
      ref={triggerRef} // NEW: Attach the ref here
      className="tooltip-wrapper"
      onMouseEnter={() => setTooltipVisible(true)}
      onMouseLeave={() => setTooltipVisible(false)}
      onMouseMove={handleMouseMove} // NEW: Add the mouse move handler
    >
      {children}

      <AnimatePresence>
        {isTooltipVisible && (
          <motion.div
            className="tooltip-box"
            variants={tooltipVariants}
            initial="hidden"
            animate="visible"
            exit="hidden"
          >
            <div className="image-container">
              <img
                src={images[currentImageIndex]}
                alt={`Tooltip content ${currentImageIndex + 1}`}
              />
            </div>
            <div className="tooltip-arrow" />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default BouncyImageTooltip;
